import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

const PrimaryButton = ({
  children,
  onClick,
  className = "",
  disabled = false,
  loading = false,
  type = "button",
  // AntD's name for the DOM `type`. Accepted rather than dropped into `...rest`, because this
  // codebase is AntD end to end and `htmlType` is what everyone reaches for — and dropping it
  // put `htmltype="submit"` on the DOM while the button stayed `type="button"`, which is how
  // nine CRM forms ended up with a submit button that could not submit anything.
  htmlType,
  ...rest
}) => {
  const handleClick = (e) => {
    if (!disabled && !loading && onClick) {
      onClick(e);
    }
  };

  const baseStyles =
    "h-[44px] px-6 rounded-md text-[13px] font-medium leading-5 transition-all duration-300 ease-in-out inline-flex items-center justify-center gap-2";

  // `bg-brand` / `bg-brand-hover` follow the theme palette (`25a-layer-base-theme-palettes.css`);
  // Classic Blue keeps the #3956ea / #2e45bb this used to carry.
  const colorStyles =
    disabled || loading
      ? "bg-brand opacity-50 cursor-not-allowed text-surface"
      : "bg-brand hover:bg-brand-hover text-surface cursor-pointer";

  return (
    <button
      type={htmlType || type}
      onClick={handleClick}
      disabled={disabled || loading}
      className={`${baseStyles} ${colorStyles} ${className}`}
      {...rest}
    >
      {loading && (
        <Spin
          indicator={
            <LoadingOutlined style={{ fontSize: 16, color: "white" }} spin />
          }
        />
      )}
      {children}
    </button>
  );
};

export default PrimaryButton;
